import { Collection } from "@/models/products/collection";
import { ProductType } from "@/models/products/product";
import { Mixins, Vue, Watch } from "vue-property-decorator";
import ProductService from "@/services/product_service";
import { APIError, NotFoundError } from "@/services/error_service";
import { formatTitle } from "@/utility/helpers";
import { Mobile } from "@/mixins/mobile";

export default class Collections extends Mixins(Mobile) {
  protected productService = new ProductService();
  protected productType = ProductType;
  protected collections: Collection[] = [];
  protected formatTitle = formatTitle;

  @Watch("product", { immediate: true })
  protected async getProductLines(productType: ProductType): Promise<void> {
    let products: Collection[] = [];
    try {
      const res = await this.productService.getProducts({
        category: productType,
        sort: productType !== ProductType.Accessory ? "productline" : undefined
      });
      products = res;
    } catch (err) {
      if (err instanceof NotFoundError) {
        NotFoundError.popup(err.message, err.statusCode);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
    }
    this.collections = products;
  }

  get product(): string {
    return this.$route.params.product
      ? (this.$route.params.product as ProductType)
      : ProductType.Umbrella; //umbrella is default if null
  }

  public selectProduct(handle: string): void {
    this.$router.push(`/items/${this.product}?handle=${handle}`);
  }
}
